export default {
    "You can select up to {count} options": "Vous pouvez sélectionner jusqu'à {count} options",
    "Please answer all required questions to continue": "Veuillez répondre à toutes les questions obligatoires pour continuer",
    "Next Section": "Section suivante",
    "Previous Section": "Section précédente",
    "Next Question": "Question suivante",
    "Previous Question": "Question précédente",
    "Complete": "Terminer",
    "Please enter all field properly": "Veuillez remplir correctement tous les champs",
    "This question is required": "Cette question est obligatoire",
    "Choose": "Choisir",
    "Other option": "Autre option",
    "Read more": "Lire la suite",
    "Show less": "Voir moins",
    "Loading": "Chargement",
    "Dashboard": "Dashboard",
    "Buy more answers": "Buy more answers",
    "Per-location QR codes": "QR codes par emplacement",
    "Rooms / Tables / Locations": "Chambres / Tables / Emplacements",
    "Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.": "Générez un QR code par emplacement (par ex. chambres 101–150 ou tables de restaurant). Chaque QR contient son emplacement, les réponses sont donc étiquetées automatiquement — le client ne le saisit jamais. Choisissez d'abord une enquête et un type de réponse ci-dessus.",
    "Add range": "Ajouter une plage",
    "Extra locations (comma-separated, e.g. T1, T2, VIP)": "Emplacements supplémentaires (séparés par des virgules, ex. T1, T2, VIP)",
    "QR per page": "QR par page",
    "Label prefix (Room / Table / Σημείο)": "Préfixe d'étiquette (Chambre / Table / Emplacement)",
    "Caption (e.g. SCAN TO ANSWER)": "Légende (ex. SCAN TO ANSWER)",
    "Sheet title (defaults to survey name)": "Titre de la feuille (par défaut : nom de l'enquête)",
    "Generate QR PDF": "Générer le PDF QR",
    "locations": "emplacements",
    "Please choose a survey": "Veuillez choisir une enquête",
    "No locations defined": "Aucun emplacement défini",
    "Too many locations (max 1000)": "Trop d'emplacements (max 1000)",
    "Invalid range (from must be <= to)": "Plage invalide (de doit être ≤ à)",
    "PDF generated": "PDF généré",
    "QR Code Sheet": "Feuille de QR codes",
    "Generated": "Généré",
    "Location": "Emplacement",
    "Location (room / table):": "Emplacement (chambre / table) :",
    "Exact / list (e.g. 205, 210)": "Exact / liste (ex. 205, 210)",
    "Range from": "Plage de",
    "Range to": "Plage à",
    "Guest": "Client",
    "Location — exact / list (e.g. 205, 210)": "Emplacement — exact / liste (ex. 205, 210)",
    "Location range from": "Plage d'emplacement de",
    "Location range to": "Plage d'emplacement à",
    "is": "est",
    "is not": "n'est pas",
    "includes": "inclut",
    "does not include": "n'inclut pas",
    "between": "entre",
    "contains": "contient",
    "does not contain": "ne contient pas",
    "on": "le",
    "before": "avant",
    "after": "après",
    "value": "valeur",
    "min": "min",
    "max": "max",
    "If answer": "Si la réponse",
    "go to": "aller à",
    "Next question (default)": "Question suivante (par défaut)",
    "Add rule": "Ajouter une règle",
    "Otherwise, go to": "Sinon, aller à",
    "Send the respondent to a different question depending on their answer to this question. Rules are checked top to bottom; the first match wins. If nothing matches, the default applies.": "Dirigez le répondant vers une autre question selon sa réponse à cette question. Les règles sont vérifiées de haut en bas ; la première correspondance l'emporte. Si aucune ne correspond, la valeur par défaut s'applique.",
    "Add this question's answer options first to build branching rules.": "Ajoutez d'abord les options de réponse de cette question pour créer des règles.",
    "Logic / Branching": "Logique / Branchement",
    "optional": "facultatif",
    "End of survey": "Fin de l'enquête",
    "A question with branching rules is answered before the survey continues.": "Une question avec des règles de branchement reçoit une réponse avant que l'enquête ne continue.",

    // reports — modern Analytical/Summary labels
    "Overall score": "Score global",
    "Responses": "Réponses",
    "Positive": "Positif",
    "positive": "positif",
    "No answers": "Aucune réponse",

    // reports — Summary period comparison
    "Period 1": "Période 1",
    "Period 2": "Période 2",
    "Compare periods": "Comparer les périodes",
    "set Period 2": "définir la période 2",

    // reports — Text reports search/sort
    "No respondents match": "Aucun répondant ne correspond à",
    "Search by location, name, email or answer text…": "Rechercher par emplacement, nom, e-mail ou texte de réponse…",
    "Sorted worst score first — the responses that need attention are at the top.": "Trié par pire score d’abord — les réponses nécessitant attention sont en haut.",

    // reports — Excel export
    "Excel export is not available for this report": "L’export Excel n’est pas disponible pour ce rapport",
    "Choose a report type above to begin": "Choisissez un type de rapport ci-dessus pour commencer",
    "Filters": "Filtres",
    "Hide filters": "Masquer les filtres",
    "Show results": "Afficher les résultats",
    "Print": "Imprimer",
    "Answer:": "Réponse :",
    "Choose a report type": "Choisissez un type de rapport",
};